module.exports = __webpack_public_path__ + "static/banner-e7e079a90fee964a153d90cdda25b197.jpg";